import { render, staticRenderFns } from "./ucMenu.vue?vue&type=template&id=07df64f3&scoped=true&"
import script from "./ucMenu.vue?vue&type=script&lang=js&"
export * from "./ucMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07df64f3",
  null
  
)

export default component.exports